/*** IMPORTS FROM imports-loader ***/
var $ = require("jquery");
var jQuery = require("jquery");

// https://github.com/DavidBruant/Map-Set.prototype.toJSON
var $export  = require('./$.export');

$export($export.P, 'Set', {toJSON: require('./$.collection-to-json')('Set')});



/*****************
 ** WEBPACK FOOTER
 ** ./~/core-js/library/modules/es7.set.to-json.js
 ** module id = 1355
 ** module chunks = 0
 **/